export enum InclusionTypeEnum {
    CommonLaw = 'commonLaw',
    Inami = 'inami',
}
